import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableParayDarhenraw from "./ScroollTableParayDarhenraw";
import FooterOfParayDarhenraw from "./FooterOfParayDarhenraw";
import FillDetailParayDarhenraw from "./FillDetailParayDarhenraw";
const AllParayDarhenraw = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailParayDarhenraw />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableParayDarhenraw />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfParayDarhenraw />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllParayDarhenraw;
